export const UserEntitlement = {
  'USER_ENTITLEMENT-ACCS_PROF': {
    entitlement: 'USER_ENTITLEMENT-ACCS_PROF',
    'description': 'ACCESS_LEVEL_PROFILE-ACCESS_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-Q_PROF': {
    entitlement: 'USER_ENTITLEMENT-Q_PROF',
    'description': 'QUEUE_LEVEL_PROFILE-QUEUE_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-MSG_PROF': {
    entitlement: 'USER_ENTITLEMENT-MSG_PROF',
    'description': 'MESSAGE_LEVEL_PROFILE-MESSAGE_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-BANK_PROF': {
    entitlement: 'USER_ENTITLEMENT-BANK_PROF',
    'description': 'DEPARTMENT_LEVEL_PROFILE-DEPARTMENT_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-ALERT_PROF': {
    entitlement: 'USER_ENTITLEMENT-ALERT_PROF',
    'description': 'ALERT_LEVEL_PROFILE-ALERT_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-PRULE_TYPE_PROF': {
    entitlement: 'USER_ENTITLEMENT-PRULE_TYPE_PROF',
    'description': 'PRULE_TYPE_LEVEL_PROFILE-RULE_TYPE_PROFILE_DESC'
  },
  'USER_ENTITLEMENT-LIMIT_PROF': {
    entitlement: 'USER_ENTITLEMENT-LIMIT_PROF',
    'description': 'LIMIT_LEVEL_PROFILE-LIMIT_PROFILE_DESCRIPTION'
  },
  'USER_ENTITLEMENT-MASKING_PROF': {
    entitlement: 'USER_ENTITLEMENT-MASKING_PROF',
    'description': 'MASKING_LEVEL_PROFILE-MASKING_PROFILE_DESCRIPTION'
  }
}
